import React, { useState } from 'react'

const EMOJI_CATEGORIES = [
  {
    name: '일반',
    emojis: ['📌', '📝', '✅', '❌', '⚠️', '💡', '🔍', '📋', '📄', '📎', '🔗', '⭐', '💫', '✨']
  },
  {
    name: '비즈니스',
    emojis: ['💼', '📊', '📈', '📉', '💰', '🏆', '🎯', '📞', '📧', '💬', '📱', '🖥️', '💻', '📱']
  },
  {
    name: '프로세스',
    emojis: ['1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '➡️', '⬅️', '⬆️', '⬇️']
  },
  {
    name: '상태/감정',
    emojis: ['😊', '😃', '😄', '👍', '👎', '❤️', '💙', '💚', '💛', '🧡', '💜', '🤝', '🙌', '👏']
  },
  {
    name: '보험/금융',
    emojis: ['🛡️', '🏦', '💳', '💵', '💴', '💶', '💷', '📈', '📉', '📊', '💼', '🏠', '🚗', '🏥']
  },
  {
    name: '기타',
    emojis: ['🚀', '⚡', '🔥', '💪', '🎉', '🎊', '🏅', '🥇', '🥈', '🥉', '🎁', '🎀', '🎈', '🎂']
  }
]

export default function EmojiPicker({ value = '', onChange, onClose }) {
  const [selectedCategory, setSelectedCategory] = useState(EMOJI_CATEGORIES[0].name)

  const handleEmojiClick = (emoji) => {
    if (onChange) {
      onChange(emoji)
    }
    if (onClose) {
      onClose()
    }
  }

  const currentCategory = EMOJI_CATEGORIES.find(c => c.name === selectedCategory) || EMOJI_CATEGORIES[0]

  return (
    <div className="absolute z-50 mt-1 rounded-lg border bg-white shadow-lg p-3" style={{ width: '320px', maxHeight: '400px' }}>
      <div className="flex items-center gap-2 mb-2 border-b pb-2">
        {EMOJI_CATEGORIES.map((cat) => (
          <button
            key={cat.name}
            type="button"
            className={`px-2 py-1 text-xs rounded ${selectedCategory === cat.name ? 'bg-blue-100 text-blue-700 font-semibold' : 'hover:bg-slate-50'}`}
            onClick={() => setSelectedCategory(cat.name)}
          >
            {cat.name}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-2 max-h-64 overflow-y-auto">
        {currentCategory.emojis.map((emoji, idx) => (
          <button
            key={idx}
            type="button"
            className="text-2xl hover:bg-slate-100 rounded p-2 transition-colors"
            onClick={() => handleEmojiClick(emoji)}
            title={emoji}
          >
            {emoji}
          </button>
        ))}
      </div>
      <div className="mt-2 pt-2 border-t text-xs text-slate-500">
        이모지를 클릭하면 선택됩니다. 직접 입력도 가능합니다.
      </div>
    </div>
  )
}
